import React, { useState, useEffect } from 'react'
import { Table, Input, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import { GetFeeApprovedList, RoomChangeHistory } from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'

const RoomChangedHistory = () => {
  const storedBranchId = sessionStorage.getItem('branch_id')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchRoomApprovedList()
  }, [])

  const fetchRoomApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${RoomChangeHistory}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: item.student.full_name,
        wh_mobile: item.student.wh_mobile || '-',
        oldRoom: item.oldRoom.room_no || '-',
        oldBed: item.oldBed.bed_no || '-',
        newRoom: item.newRoom.room_no || '-',
        newBed: item.newBed.bed_no || '-',

        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (item.full_name ?? '').toLowerCase().includes(search)
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: "What's App No.", dataIndex: 'wh_mobile' },
    { title: 'Previous Room', dataIndex: 'oldRoom' },
    { title: 'Previous Bed', dataIndex: 'oldBed' },
    { title: 'New Room', dataIndex: 'newRoom' },
    { title: 'New Bed', dataIndex: 'newBed' },
  ]

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Student Name': item.full_name,
      'WhatsApp No': item.wh_mobile,
      'Previous Room': item.oldRoom,
      'Previous Bed': item.oldBed,
      'New Room': item.newRoom,
      'New Bed': item.newBed,
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
    ]

    const workbook = XLSX.utils.book_new()

    // Sheet name should be <= 31 characters
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Room Change History')

    XLSX.writeFile(workbook, 'Room_Changed_History.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Room Changed History</h2>
          </div>

          <div
            className="d-flex justify-content-between align-items-center mb-3 flex-wrap"
            style={{ gap: '10px' }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>

            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default RoomChangedHistory
